import './style.scss'
import UserIndicator from '../../components/userIndicator/UserIndicator';
import QuickSearch from '../../components/quickSearch/QuickSearch';
import { useAppSelector } from '../../redux/hooks';
import MobileQuickSearch from '../../components/mobileQuickSearch/MobileQuickSearch';
// import HeaderLogo from './logo/HeaderLogo';
import HomePageSwitch from '../../components/homePageSwitch/HomePageSwitch';
// import HeaderLogoLanding from './logo/HeaderLogoLanding';
import HeaderLogoSearch from './logo/HeaderLogoSearch';

function HeaderSearch() {
	const useMobileLayout = useAppSelector(state => state.resize.useMobileLayout)
	const showQuickSearchMobile = useAppSelector(state => state.search.showQuickSearchMobile)

	return (
		<div className="header-wrap">
			<div className='header-top-wrap'>
				{/* <HeaderLogo /> */}
				<HeaderLogoSearch />
				<HomePageSwitch isLandingPage={false} />
				{useMobileLayout &&
					<MobileQuickSearch />
				}
				<UserIndicator />
			</div>
			{useMobileLayout && showQuickSearchMobile &&
				<div className='header-search-wrap'>
					<QuickSearch />
				</div>
			}
			{!useMobileLayout &&
				<div className='header-search-wrap'>
					<QuickSearch />
				</div>
			}
		</div>
	)
}

export default HeaderSearch